<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('question.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('question.pageTitle'),
            href: '/questions'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <staff-question-create v-if="isStaff" />
  </div>
</template>
<script>
import StaffQuestionCreate from './staff/create'

export default {
  name: 'questionCreate',
  components: {
    StaffQuestionCreate
  },
  data() {
    return {}
  },
  computed: {
    isStaff() {
      return this.$store.getters.isStaffLogin
    }
  }
}
</script>
